import React from 'react';

const BackArrow = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.27906 15.5027L7.87568 16.0994L9.06893 14.9061L8.4723 14.3095L4.00643 9.84363H16.0319H16.8757V8.15613H16.0319H4.00643L8.4723 3.69025L9.06893 3.09363L7.87568 1.90039L7.27906 2.49701L1.57169 8.20438C1.13235 8.64372 1.13235 9.35604 1.57169 9.79537L7.27906 15.5027Z"
        fill="#1D1D1D"
      />
    </svg>
  );
};

export default BackArrow;
